import { faCheck, faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { HBox, VBox } from '../../../components/Box';
import { Button } from '../../../components/Buttons';
import { Card } from '../../../components/Card';
import { Loader } from '../../../components/Loader';
import { Notification } from '../../../components/Notification';
import { Permission } from '../../../components/Permission';
import {
  COMPANY_DOCUMENTS_CRUD,
  COMPANY_FINANCIAL_DETAILS,
  COMPANY_SYNC_WITH_EXACT,
  INVOICES_PAGE,
} from '../../../components/Permission/constants';
import { selectUserId, selectWork, selectWorks } from '../../Api/selectors';
import { fetchCompanyInvoices } from '../../Invoices/actions';
import { REQUEST_COMPANY_INVOICES } from '../../Invoices/constants';
import { selectInvoices } from '../../Invoices/selectors';
import { checkVies, syncExactId, toggleNotification } from '../actions';
import { CompanyAddressesCard } from '../components/CardAddresses';
import { CompanyDataCard } from '../components/CardData';
import { CompanyDocumentsCard } from '../components/CardDocuments';
import { CompanyFinanceDataCard } from '../components/CardFinancialInfo';
import { CompanyInfoCard } from '../components/CardInfo';
import { CompanyInvoicesCard } from '../components/CardInvoices';
import { CompanyRemarksCard } from '../components/CardRemarks';
import { CompanyStructureCard } from '../components/CardStructure';
import { CompanyRoles } from '../components/CompanyRoles';
import { CompanyUsers } from '../components/CompanyUsers';
import { CompanyOwnerCard } from '../components/CardOwner';
import { CompanyAttRemarksCard } from '../components/CardCompanyAttrRemarks';
import env from '../../../env';
import { selectNotification } from '../selectors';
import { AppClientId } from '../../Shared/constants';
import styles from './detailsColumns.module.css';
import cn from 'classnames';
import ButtonComponent from '../../../containers/App/Components/Button/Button';
import { REQUEST_COMPANY_PROPERTY_UPDATE } from '../constants';
import { CompanyCreditInfoCard } from '../components/CardCreditInfo';

//comment1
const Container = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    max-width: 100%;
  }
  .info-card {
    min-width: 260px;
    width: 100%;
    margin: 10px 0;
  }

  .info-card.wide {
    width: 99%;
  }

  .info-card-fin.wide {
    width: 99%;
  }

  .company-info-card info-card {
    &.misc {
      .button {
        margin: 2px;
        background-color: #ddd;
        color: #333;
      }
    }
  }

  .vbox.col {
    width: auto;

    @media (max-width: 768px) {
      width: 100%;
      margin: 6px 0;
    }
  }
`;

const Wrapper = styled.div`
  // display: flex;
  // flex-direction: row;
  // justify-content: space-between;
  /* justify-content: flex-start; */
  display: grid;
  grid-template-columns: 49% 49%;
  gap: 10px;
  width: 100%;
  @media (max-width: 1440px) {
    gap: 5px;
    width: 100%;
  }
  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    justify-content: center;

    & > div {
      width: 100%;
    }
  }
`;

/* eslint-disable react/prefer-stateless-function */
class CompanyDetailsColumnsComp extends BaseComponent {
  constructor(props) {
    super(props, {});
  }

  componentDidMount() {
    this.props.fetch();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.notification?.isShow) {
      this._t = this.timeout(
        () => {
          this.props.toggleNotification();
        },
        5000,
        this._t,
      );
    }
  }

  get company() {
    return this.props.company;
  }

  handleSync = () => {
    this.props.syncExactId(this.props.company.id);
  };

  renderThirdColumn(company) {
    return (
      <>
        <Permission permission={COMPANY_DOCUMENTS_CRUD}>
          <CompanyDocumentsCard company={this.props.company} />
        </Permission>
        <Card className="company-info-card info-card misc">
          <h2>other</h2>
          <div className={styles.containerButton}>
            <Button className={styles.buttonEdit} primary onClick={() => this.to(`/companies/${this.company.id}/edit`)}>
              {this.lbl('company.details.columns.edit_company')}
            </Button>
            {!env.hide_other_buttons && (
              <Button className={styles.button} onClick={this.tofn(`/companies/${this.company.id}`)}>
                {this.lbl('company.details.columns.title')}
              </Button>
            )}
            <Button className={styles.button} onClick={this.tofn(`/companies/${this.company.id}/vars`)}>
              {this.lbl('company.details.title')}
            </Button>
            {!env.clientId === AppClientId.INDEWAL && (
              <Button className={styles.button} onClick={() => this.to(`/companies/${this.company.id}/dun`)}>
                {this.lbl('company.details.columns.dun')}
              </Button>
            )}
            <Button className={styles.button} onClick={this.tofn(`/companies/${this.company.id}/history`)}>
              Logs
            </Button>

            <HBox vCenter>
              {this.props.company.properties?.findIndex(p => p?.name?.name === 'exactId') >= 0 ? (
                <HBox vCenter left style={{ color: 'green', gap: 10 }}>
                  <FontAwesomeIcon icon={faCheck} />
                  Synced
                </HBox>
              ) : (
                <HBox vCenter left style={{ color: 'red', gap: 10 }}>
                  <FontAwesomeIcon icon={faTimes} />
                  Not synced
                </HBox>
              )}
              <Permission permission={COMPANY_SYNC_WITH_EXACT}>
                <Button className={styles.button} small onClick={this.handleSync}>
                  Sync with exact
                </Button>
              </Permission>
            </HBox>
          </div>
        </Card>
        {env.clientId !== AppClientId.HILTERMANN && (
          <CompanyRoles className={styles.companyRoles} company={this.props.company} />
        )}
        {env.clientId !== AppClientId.HILTERMANN && (
          <CompanyUsers className={styles.CompanyUsers} company={this.props.company} companyDetails />
        )}
      </>
    );
  }

  render() {
    const company = this.props.company;
    if (this.props.work) return <Loader small />;
    return (
      <Container className={styles.containerPage}>
        {this.props.notification?.isShow == '1' && (
          <Notification>{this.lbl(`company.create.${this.props.notification?.message}`)}</Notification>
        )}

        <VBox left className={cn('col', styles.firstColumn)} top>
          <CompanyInfoCard company={this.props.company} />
          <CompanyDataCard company={this.props.company} />
          {company['company_from_eu'] != 'NL' && env.clientId === AppClientId.AUTOWIENTJES && (
            <CompanyOwnerCard company={this.props.company} />
          )}
          {window.innerWidth > 768 && window.innerWidth < 1400 && this.renderThirdColumn()}
        </VBox>

        <VBox left className="col" top>
          <>
            <Wrapper>
              <VBox top>
                <Permission permission={COMPANY_FINANCIAL_DETAILS}>
                  <CompanyFinanceDataCard company={this.props.company} />
                </Permission>
                {this.props.workAttRemarks && env.clientId === AppClientId.AUTOWIENTJES ? (
                  <Loader small />
                ) : (
                  <CompanyAttRemarksCard company={this.props.company} loggedUserId={this.props.loggedInUserId} />
                )}
                {this.props.workUpdate ? (
                  <Loader small />
                ) : (
                  <CompanyRemarksCard company={this.props.company} loggedUserId={this.props.loggedInUserId} />
                )}
              </VBox>

              <VBox top>
                <HBox>
                  <VBox>
                    <CompanyAddressesCard company={this.props.company} />
                    {!env.hide_company_structure_card && <CompanyStructureCard company={this.props.company} />}
                  </VBox>
                  {/* <VBox><CompanyFinanceSalesCard company={this.props.company} /></VBox> */}
                </HBox>
              </VBox>
            </Wrapper>
            {AppClientId == AppClientId.INDEWAL && (
              <Permission permission={COMPANY_FINANCIAL_DETAILS}>
                <CompanyCreditInfoCard company={this.props.company} />
              </Permission>
            )}
            {env.clientId !== AppClientId.HILTERMANN && (
              <Permission permission={INVOICES_PAGE}>
                <Card className={cn('vehicle-info-card-fin info-card-fin data wide', styles.card)} style={{ width: '100%' }}>
                  <CompanyInvoicesCard company={this.props.company} />
                </Card>
              </Permission>
            )}

            {env.clientId == AppClientId.INDEWAL && (
              <Permission permission={COMPANY_FINANCIAL_DETAILS}>
                <CompanyCreditInfoCard company={this.props.company} />
              </Permission>
            )}
          </>
        </VBox>

        {window.innerWidth > 1400 && (
          <VBox left className={cn('col align-items-end', styles.thirdColumn)} top>
            {this.renderThirdColumn(this.props.company)}
          </VBox>
        )}

        {window.innerWidth < 748 && (
          <VBox left className={cn('col align-items-end', styles.thirdColumn)} top>
            {this.renderThirdColumn(this.props.company)}
          </VBox>
        )}
      </Container>
    );
  }
}

CompanyDetailsColumnsComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    invoices: selectInvoices(),
    work: selectWorks([REQUEST_COMPANY_INVOICES]),
    workAttRemarks: selectWork(`${REQUEST_COMPANY_PROPERTY_UPDATE}-attRemarks`),
    notification: selectNotification(),
    loggedInUserId: selectUserId(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    syncExactId(companyId) {
      dispatch(syncExactId(companyId));
    },
    fetch(callback) {
      dispatch(fetchCompanyInvoices(ownProps.company?.id));
    },
    fetchVies(dto, callback) {
      dispatch(checkVies(ownProps.company?.id, dto, callback));
    },
    toggleNotification() {
      dispatch(toggleNotification('0'));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const CompanyDetailsColumns = compose(withConnect, withRouter)(CompanyDetailsColumnsComp);
